import React, { Component } from "react";
import { connect } from "react-redux";
import { setJumbotronTitle } from "../../actions/common";
import WithAjax from "../common/helpers/WithAjax";
import ProfileList from "./helpers/ProfileList";

class RejectedProfiles extends Component {
  constructor() {
    super();

    this.state = {
      items: [],
    };

    this.columns = ["AvatarImage", "SkillVendorFullName", "ProfileTypeLabel", "StatusModifiedDate", "SamplesFolderModifiedOn"];

    this.columnNames = ["", "Full name", "Profile type", "Status modified date", "Samples updated date"];

    this.tableSortDefinition = [
      "SkillVendorFullName",
      "ProfileTypeLabel",
      {
        column: "StatusModifiedDate",
        sortFunction: function(a, b) {
          return a.props.statusmodifieddate.localeCompare(b.props.statusmodifieddate);
        },
      },
      {
        column: "SamplesFolderModifiedOn",
        sortFunction: function(a, b) {
          let valueA = a.props.samplesfoldermodifiedon || "";
          let valueB = b.props.samplesfoldermodifiedon || "";

          return valueA.localeCompare(valueB);
        },
      },
    ];
  }

  componentDidMount() {
    this.props.setJumbotronTitle("Rejected profiles");

    let url = "profiles/rejected";
    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return (data[index].NavigationParam = data[index].SkillVendorId);
      });

      let items = data.map((item) => {
        return Object.assign({}, item, {
          SamplesFolderModifiedOn: <span samplesfoldermodifiedon={item.SamplesFolderModifiedOn}>{item.SamplesFolderModifiedOnAsString}</span>,
        });
      });

      this.setState({
        items: items,
      });
    });
  }

  render() {
    return (
      <ProfileList
        urlExport="profiles/export/rejected"
        columns={this.columns}
        label={"Rejected"}
        columnNames={this.columnNames}
        items={this.state.items}
        tableSortDefinition={this.tableSortDefinition}
        filterable={[
          {
            column: "ProfileTypeLabel",
            filters: "auto",
          },
        ]}
        searchable={["SkillVendorFullName"]}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(RejectedProfiles));
